import { challengeSignAuthV2Handler } from '../challengeSignAuthV2/mock'
import { completeAgreementHandler } from '../completeAgreement/mock'
import { createExplanationHandler } from '../createExplanation/mock'
import { createExplanationRevisionHandler } from '../createExplanationRevision/mock'
import { createSessionHandler } from '../createSession/mock'
import { deliveryDocumentsHandler } from '../deliveryDocuments/mock'
import { disableExplanationRevisionHandler } from '../disableExplanationRevision/mock'
import { finishSessionHandler } from '../finishSession/mock'
import { getExplanationHandler } from '../getExplanation/mock'
import { getExplanationHistoryHandler } from '../getExplanationHistory/mock'
import { getExplanationsHandler } from '../getExplanations/mock'
import { getExplanationWithdrawHistoriesHandler } from '../getExplanationWithdrawHistories/mock'
import { getExplanationSessionHandler } from '../getSession/mock'
import { getExplanationTrialHospitalsHandler } from '../getTrialHospitals/mock'
import { getExplanationTrialMembersHandler } from '../getTrialMembers/mock'
import { rejectAgreementHandler } from '../rejectAgreement/mock'
import { requestPinSettingHandler } from '../requestPinSetting/mock'
import { resendAuthCodeByVoiceHandler } from '../resendAuthCodeByVoice/mock'
import { resendSignAuthEmailHandler } from '../resendSignAuthEmail/mock'
import { sendTestEmailHandler } from '../sendTestEmail/mock'
import { sendTestSMSHandler } from '../sendTestSMS/mock'
import { sendVideoCallStartedNotificationHandler } from '../sendVideoCallStartedNotification/mock'
import { setExpDocRevisionSignerMemberHandler } from '../setExpDocRevisionSignerMember/mock'
import { setPinHandler } from '../setPin/mock'
import { setPinForPatientHandler } from '../setPinForPatient/mock'
import { syncAllEnvelopesHandler } from '../syncAllEnvelopes/mock'
import { syncEnvelopeHandler } from '../syncEnvelope/mock'
import { updateDeliveryDateHandler } from '../updateDeliveryDate/mock'
import { updateExpMembersHandler } from '../updateExpMembers/mock'
import { updatePreSessionIdentificationHandler } from '../updatePreSessionIdentification/mock'
import { verifyOTPHandler } from '../verifyOTP/mock'
import { verifyPinHandler } from '../verifyPin/mock'
import { withdrawExplanationHandler } from '../withdrawExplanation/mock'
import { updateWithdrawExplanationHandler } from './../updateWithdrawExplanation/mock'

export const explanationsHandlers = [
  completeAgreementHandler(),
  createExplanationHandler(),
  createExplanationRevisionHandler(),
  createSessionHandler(),
  deliveryDocumentsHandler(),
  disableExplanationRevisionHandler(),
  finishSessionHandler(),
  getExplanationHandler(),
  getExplanationHistoryHandler(),
  getExplanationsHandler(),
  getExplanationTrialHospitalsHandler(),
  getExplanationWithdrawHistoriesHandler(),
  getExplanationSessionHandler(),
  getExplanationTrialMembersHandler(),
  rejectAgreementHandler(),
  resendSignAuthEmailHandler(),
  sendTestEmailHandler(),
  sendTestSMSHandler(),
  setExpDocRevisionSignerMemberHandler(),
  syncAllEnvelopesHandler(),
  syncEnvelopeHandler(),
  updateDeliveryDateHandler(),
  updateExpMembersHandler(),
  updatePreSessionIdentificationHandler(),
  updateWithdrawExplanationHandler(),
  withdrawExplanationHandler(),
  requestPinSettingHandler(),
  setPinHandler(),
  setPinForPatientHandler(),
  verifyPinHandler(),
  resendAuthCodeByVoiceHandler(),
  challengeSignAuthV2Handler(),
  verifyOTPHandler(),
  sendVideoCallStartedNotificationHandler(),
]
